
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Panel from 'vux/src/components/panel/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {get,post} from '../api'
export default {
components: {
Tabbar,
TabbarItem,
Panel,
XHeader,
Tab,
TabItem,
Cell,
Toast
},
methods: {
onItemClick () {
console.log('click tab', this.tabIndex);
if(this.isManager==true){
this.getComplaintInfos({ComplaintType:this.tabIndex});
}
else{
this.getComplaintInfos({ComplaintType:this.tabIndex,Complainter:this.GLOBAL.currentUser.BusinessGuid});
}
},
addInfos(){
this.$router.push({ path: '/ComplaintAction?tag=A&type='+this.tabIndex });
},
getComplaintInfos(parameter){
this.complaintInfo=[];
this.complaintDatas=[];
post('/complaintinfo/query', parameter).then(response => {

if(response.code==1){
this.complaintDatas=response.data;
let index=0;
let picUrl=this.GLOBAL.auditCheckUrl;
response.data.forEach(element => {
if(element.Status==0){
picUrl=this.GLOBAL.auditNoUrl;
}
else if(element.Status==1){
picUrl=this.GLOBAL.auditPassUrl;
}
else if(element.Status==-1){
picUrl=this.GLOBAL.auditCheckUrl;
}
if(this.isManager==true){
this.complaintInfo.push({
src: picUrl,
title:element.Title,
desc:element.Content,
url: '/ComplaintDetail?id='+index+'&type='+this.tabIndex
})
}
else{
this.complaintInfo.push({
src: picUrl,
title:element.Title,
desc:element.Content,
url: '/ComplaintAction?id='+index+'&tag=E&type='+this.tabIndex
})
}
index++;
});
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
},
onClickItem(){
this.GLOBAL.currentObjs=this.complaintDatas;
}
},
mounted() {
if(this.GLOBAL.currentUser==undefined){
this.$router.push({ path: '/' });
}
let tag = this.$route.query.tag;
if(tag=='M'){
this.isManager=true;
this.getComplaintInfos({ComplaintType:this.tabIndex});
}
else if(tag=='B'){
this.getComplaintInfos({ComplaintType:this.tabIndex,Complainter:this.GLOBAL.currentUser.BusinessGuid});
}
console.log(tag);
},
data () {
return {
type: '5',
complaintDatas:[],
complaintInfo: [],
footer: {
title: "",
url: ''
},
isManager:false,
tabIndex:0,
showSuccess:false,
showWarn:false,
showError:false,
SuccessInfo:'投诉查询成功!',
WarnInfo:'',
ErrorInfo:'系统异常,联系管理员!'
}
}
}



// WEBPACK FOOTER //
// ./src/components/ManagerModules/ComplaintInfo.vue